exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.selected_1[data-v-6d2ed4fe] {\n  width:45%;\n  margin:1px;\n  text-align:left;\n}\n.item_0[data-v-6d2ed4fe] {\n  cursor:pointer;\n  display:inline-block;\n  background-color: #fff;\n  border: 1px solid #ebedf0;\n  width:45%;\n  margin: 1px;\n  text-align:left;\n  min-width: 60px;\n  height: 30px;\n  padding: 0 8px;\n  font-size: 12px;\n  line-height: 28px;\n}\n.item_0[data-v-6d2ed4fe]:hover {\n  -webkit-box-shadow: 1px 1px 10px 5px #e6e9da;\n          box-shadow: 1px 1px 10px 5px #e6e9da;\n}\n.item_0_selected[data-v-6d2ed4fe] {\n  border-color: #7370d4;\n  background: rgb(204,232,255);\n  color: #4566e6;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6d2ed4fe","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/mobile-ticket/MobileTicketTypePicker.vue
// module id = 646
// module chunks = 75